import React from 'react';
import PropTypes from "prop-types";

const LoadingSpinner = ({type = '', size = 'sm'}) => {
    return (
        <div className={"lds-ring " + type + " " + size}>
            {[...TB.range(1, 5)].map(index => (
                <div key={`ring-${index}`}/>
            ))}
        </div>
    );
};

LoadingSpinner.propTypes = {
    type: PropTypes.any,
    size: PropTypes.oneOf(['sm', 'lg']),
}

export default LoadingSpinner
